define( function() {
	return ( /<([\w:-]+)/ );
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/manipulation/var/rtagName.js
// module id = 875
// module chunks = 0